<template lang="pug">
  EditDialog(ref="EditDialog" title="積荷種別" :recordId="record.id" @delete="erase" @save="save"
    :loadingSave="loading.save" :loadingDelete="loading.delete")
    template(v-slot:body)
      v-container(grid-list-md)
        v-layout(row wrap)
          v-flex(xs12 md12)
            v-text-field(v-model="record.name" label="積荷種別" :error-messages="getErrorMessages('name')")
          v-flex(xs12 md6)
            StatusSelect(:code.sync="record.status" :errorHandlerMethod="getErrorMessages")

</template>

<script>
import EditDialog from "@/components/common/dialog/EditDialog";

import ApiHandler from "../../../mixin/ApiHandler";
import EditForm from "../../../mixin/EditForm";
import StatusSelect from "@/components/common/select/StatusSelect";
import * as Enum from "@/assets/js/enum";

export default {
  components: {
    EditDialog,
    StatusSelect
  },
  mixins: [ApiHandler, EditForm],
  data() {
    return {
      record: {}
    };
  },
  methods: {
    initData() {
      return {
        id: null,
        name: null,
        status: Enum.ActiveFlag.Active.code
      };
    },
    openDialog(item) {
      this.initForm(item);
      this.$refs.EditDialog.openDialog();
    },
    closeDialog() {
      this.$refs.EditDialog.closeDialog();
    },
    save() {
      const self = this;
      this.saveRecord().then(value => {
        self.closeDialog();
      });
    },
    erase() {
      const self = this;
      this.deleteRecord().then(value => {
        self.closeDialog();
      });
    }
  },
  created() {
    this.record = this.initData();
  }
};
</script>
